export default "__VITE_ASSET__B3S7f$HL__"